import React, { useState } from "react";
import user_service from "../service/user_service";
import { FEE_STRUCTURE_ACK_VERSION } from "../../constants/fees.js";

const FeeStructureAcknowledgmentModal = ({ contactId, onAcknowledged }) => {
  const [isAcknowledged, setIsAcknowledged] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleConfirm = async () => {
    if (!isAcknowledged || !contactId) {
      return;
    }

    setIsSubmitting(true);
    setError("");

    try {
      const response = await user_service.contactUpdate(contactId, {
        fee_structure_ack_version: FEE_STRUCTURE_ACK_VERSION,
        fee_structure_acknowledged_at: new Date().toISOString(),
      });

      if (response) {
        onAcknowledged(response.data);
      }
    } catch (submitError) {
      setError("Unable to save your acknowledgment. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="modal show"
      role="dialog"
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      data-backdrop="static"
      data-keyboard="false"
    >
      <div
        className="modal-dialog modal-lg modal-dialog-scrollable"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Important Fee Structure Update</h4>
          </div>
          <div className="modal-body fs-lg">
            <p>
              We continue to offer some of the most affordable commission plans
              available to real estate professionals, along with the quality,
              service, technology, and support you expect from In Depth Realty.
            </p>
            <p>
              Our commitment to you has not changed. What has changed are the
              economic conditions and rising costs of operating a brokerage.
            </p>
            <p>
              To remain sustainable and continue offering a competitive
              flat-fee model, we are making the following changes effective
              September 1, 2026.
            </p>

            <h5 className="mt-4">New Fees</h5>
            <ul>
              <li>Transaction Fee: $595.00 on all transactions</li>
              <li>
                Brokerage Administrative Fee: $199.00 on all buyer and seller
                representation transactions
              </li>
              <li>No monthly or annual affiliation fee</li>
              <li>
                E&amp;O insurance continues to be included in the $595.00
                transaction fee
              </li>
            </ul>
            <p>
              The $199.00 Brokerage Administrative Fee is paid by the buyer or
              seller and must be included in the applicable Buyer Broker
              Agreement or Listing Agreement.
            </p>
            <p>
              The fee should be shown as a separate line item on the Closing
              Disclosure or Settlement Statement.
            </p>

            <h5 className="mt-4">What You Need to Do</h5>
            <p>Beginning September 1, 2026:</p>
            <ul>
              <li>$595.00 transaction fee will apply on all transactions.</li>
              <li>
                Add the $199.00 Brokerage Administrative Fee to all applicable
                Buyer Broker Agreements and Listing Agreements.
              </li>
              <li>Explain the $199.00 fee to your client.</li>
              <li>
                Provide the new In Depth Realty wire instructions to the title
                company early in the transaction.
              </li>
              <li>
                Make sure the applicable fees are properly reflected on the
                closing documents.
              </li>
            </ul>

            <h5 className="mt-4">Updated Agreement Required</h5>
            <p>
              You will be required to review and electronically sign the updated
              Agent Agreement before continuing to access the In Depth Realty
              platform.
            </p>
            <p>
              Once signed, a copy will automatically be saved to your Documents
              section and retained in your brokerage file.
            </p>
            <p>
              Thank you for your continued trust and affiliation with In Depth
              Realty. Our goal is to continue providing a competitive flat-fee
              brokerage model with the service, support, and technology you need
              to succeed.
            </p>

            <div className="form-check mt-4">
              <input
                className="form-check-input"
                type="checkbox"
                id="feeStructureAckCheckbox"
                checked={isAcknowledged}
                onChange={(event) => setIsAcknowledged(event.target.checked)}
              />
              <label
                className="form-check-label"
                htmlFor="feeStructureAckCheckbox"
              >
                I have read and understood this fee structure update
              </label>
            </div>

            {error ? <p className="text-danger mt-3 mb-0">{error}</p> : null}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              disabled={!isAcknowledged || isSubmitting}
              onClick={handleConfirm}
            >
              {isSubmitting ? "Saving..." : "Confirm"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeeStructureAcknowledgmentModal;
